import useFetch from '@hooks/useFetch';
import { useMemo } from 'react';
import { HOST_TYPE } from '@utils/api-helper/host';

const useOfflineCentreEnabledGoals = () => {
  const offlineCentreEnabledGoalsSWRKey = 'api/offline-centres-enabled-goals';

  const { data: offlineCentresGoalList, ...rest } = useFetch(
    offlineCentreEnabledGoalsSWRKey,
    { hostType: HOST_TYPE.CMS },
    { errorRetryCount: 1 }
  );

  const processedCentreInfo = useMemo(() => {
    if (!offlineCentresGoalList || offlineCentresGoalList?.error) return null;
    if (offlineCentresGoalList) return offlineCentresGoalList;
  }, [offlineCentresGoalList]);

  return {
    offlineCentresGoalList: processedCentreInfo,
    ...rest
  };
};

export default useOfflineCentreEnabledGoals;
